var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMarket = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3338 7.37679L18.8632 2.56872C17.0959 1.5656 14.9041 1.5656 13.1368 2.56872L4.66624 7.37679C2.94141 8.35583 1.88235 10.1426 1.88235 12.0736L1.88235 21.9264C1.88235 23.8574 2.94141 25.6442 4.66624 26.6232L13.1368 31.4313C14.9041 32.4344 17.0959 32.4344 18.8632 31.4313L27.3338 26.6232C29.0586 25.6442 30.1176 23.8574 30.1176 21.9264L30.1176 12.0736C30.1176 10.1426 29.0586 8.35583 27.3338 7.37679ZM19.8176 1.00312C17.4612 -0.334374 14.5388 -0.334373 12.1824 1.00312L3.71185 5.81118C1.41207 7.11658 0 9.49894 0 12.0736L0 21.9264C0 24.5011 1.41208 26.8834 3.71185 28.1888L12.1824 32.9969C14.5388 34.3344 17.4612 34.3344 19.8176 32.9969L28.2882 28.1888C30.5879 26.8834 32 24.5011 32 21.9264V12.0736C32 9.49895 30.5879 7.11658 28.2882 5.81118L19.8176 1.00312Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 24H9C8.44772 24 8 24.4477 8 25C8 25.5523 8.44772 26 9 26H17C17.5523 26 18 25.5523 18 25C18 24.4477 17.5523 24 17 24Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 22H11C10.4477 22 10 22.4477 10 23V24C10 24.5523 10.4477 25 11 25H15C15.5523 25 16 24.5523 16 24V23C16 22.4477 15.5523 22 15 22Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7273 22.3636L18.6364 15.2727L20.5455 13.3636C20.9091 13.7273 21.4545 13.7273 21.8182 13.3636C22.1819 13 22.1818 12.4546 21.8182 12.0909L18 8.27272C17.6364 7.90909 17.0909 7.90909 16.7273 8.27272C16.3636 8.63634 16.3637 9.18179 16.7273 9.54546L11.6364 14.7273C11.2727 14.3637 10.6363 14.3637 10.2727 14.7273C9.90909 15.0909 9.90909 15.6364 10.2727 16L14.1818 19.8182C14.5454 20.1818 15.0909 20.1818 15.4545 19.8182C15.8182 19.4546 15.8182 18.9091 15.4545 18.5455L17.3636 16.6364L24.4545 23.7273C24.8181 24.0909 25.3636 24.0909 25.7273 23.7273C26.0909 23.3637 26.0909 22.7273 25.7273 22.3636Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMarket);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/market.310415e7737923aac42db80a4fb3bb01.svg";